function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M603.95212,609.22395s-70-94-85-100-34-10-45,4-141,178-141,178-46,47-69,38c0,0-12,10,16,12s54-6,54-6,17,3,29,6,27,4,26-4l-4-32s103-85,106-121c0,0-2-17,0-15s44,47,63,57,66,24,66,24Z",
  transform: "translate(-31.45212 -103.72389)",
  fill: "#a0616a"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 679.5,
  cy: 271.50006,
  rx: 6.5,
  ry: 11.5,
  fill: "#a0616a"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 679.00001,
  cy: 266.00007,
  r: 11,
  fill: "#f2f2f2"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 679.00003,
  cy: 266.00007,
  r: 3,
  fill: "#ff6584"
});

function SvgHeaderImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "ebf3a80a-68e4-4533-be35-e3aec350643c",
    "data-name": "Layer 1",
    width: 1137.09575,
    height: 692.55222,
    viewBox: "0 0 1137.09575 692.55222",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M987.3059,181.51994,966.881,232.95287c3.95179,17.89039,7.818,38.06555,10.92047,59.54949l36.36564-76.10438.59616.91752c-8.3313-14.39878-17.805-26.82155-28.08519-36.643Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.18209,229.81571l19.78563-49.82136c-11.601-10.908-24.21321-18.50312-37.37072-21.85533-.68455-.17438-1.366-.32685-2.04705-.47681C948.13742,162.38375,957.26964,190.15836,966.18209,229.81571Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.75308,340.152l.45926,1.14062q-.73146-11.64813-2.29823-23.04718l-63.21975,79.01067-.23049-.51284q-.20506,6.99369-.615,13.79789Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.21345,273.68953l.53233,1.04815a258.75343,258.75343,0,0,0-23.41023-56.41425l-37.05922,77.55419q4.22386,30.224,5.6533,58.32989Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.4795,223.41593a216.052,216.052,0,0,0-9.86933,42.41262l129.01636,75.37366c-1.15383-16.236-2.9013-31.77019-4.92709-46.12465L862.3408,224.63624Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.90669,282.67l.11744-1.22754,131.46253,74.33178q-.27891-5.98183-.67228-11.86013L852.32191,268.26234l.12553-1.22576Q851.46254,274.66564,850.90669,282.67Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1047.21633,315.68348l.49428,1.09987a309.00217,309.00217,0,0,0-8.59518-40.75622l-55.01774,81.60695q.84669,18.74678.42572,36.40162Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M977.336,461.99736c-5.24518,26.02921-13.28946,49.24064-24.06422,69.36865,15.06636-12.84636,74.87981-67.24676,92.58329-135.20639Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M854.42546,341.70151a298.92474,298.92474,0,0,0,11.04459,38.46068l.205-1.33038,110.48,80.35763a371.63061,371.63061,0,0,0,5.75255-44.16556Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.75741,230.16087c-9.65349-42.90409-19.54617-71.74153-19.68918-72.155l.61937-.53055c-20.213-4.15449-38.80891,2.44285-54.11643,17.25934Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.61631,414.05048c-.09537,1.40589-.18418,2.81814-.29266,4.21155A369.22,369.22,0,0,1,978.1,458.098l67.86936-65.21372.42252,1.12945a146.38012,146.38012,0,0,0,4.42141-36.67938q-.08073-7.2869-.50677-14.51174Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M976.2886,292.21425c-3.08216-21.2378-6.9096-41.17388-10.81817-58.85529L890.6053,176.66049l.19491-1.18109c-11.43,11.35113-20.9783,27.33462-27.93888,46.86719Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M975.6998,461.50472,866.02837,381.735c27.181,75.31527,80.18965,147.6696,83.58435,152.263C962.17353,511.94808,970.49429,487.22033,975.6998,461.50472Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M982.02352,412.4907l.06312-.06741a501.54117,501.54117,0,0,0,.51673-53.9848l-131.786-74.51486q-.7047,10.84765-.58894,22.3068a179.7112,179.7112,0,0,0,3.58432,32.51911Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1167.585,467.774l-48.53576,26.58578c-8.36713,16.2995-18.25744,34.30413-29.57073,52.82964l76.549-35.42025-.126,1.08691c2.76707-16.40363,3.39393-32.014,1.74056-46.13525Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1120.51187,491.49784l47.0155-25.75231c-1.97766-15.80057-6.84719-29.69446-14.84287-40.66836-.416-.57092-.84363-1.123-1.27251-1.67287C1149.62317,428.05329,1138.94166,455.26968,1120.51187,491.49784Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1114.50321,629.78057l-.37379,1.17142q6.866-9.43779,12.92976-19.21654l-99.08539,20.53069.14959-.542q-4.61862,5.25567-9.27421,10.2347Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1148.0063,571.23169l-.25853,1.1468a258.75306,258.75306,0,0,0,17.95154-58.38106l-78.00785,36.0945q-16.02414,25.97224-32.84957,48.53083Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.7231,420.42574a216.05175,216.05175,0,0,0-34.65266,26.37094l51.2926,140.34058c9.46692-13.24074,18.029-26.31956,25.6242-38.6673l-43.1493-127.19283Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.01668,458.68132l.8734-.87054,53.84114,141.09834q3.6005-4.785,7.04679-9.56334L1008.29612,448.4873l.87848-.864Q1003.55013,452.87094,998.01668,458.68132Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1128.15585,609.31716l-.32082,1.16237a309.00347,309.00347,0,0,0,19.375-36.87215l-94.42424,27.76168q-11.30484,14.9786-22.88961,28.30767Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M981.01356,677.43587c-20.64159,16.702-41.64182,29.44842-62.77838,38.07849,19.79756-.28458,100.56265-4.03328,157.54336-45.08354Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.07564,506.39107a298.92381,298.92381,0,0,0-16.02438,36.66642l1.0064-.89392L981.89493,674.52a371.62606,371.62606,0,0,0,32.6-30.34679Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.19446,490.855c19.92985-39.20142,30.70357-67.72141,30.85711-68.13105l.81542-.01358c-12.91808-16.09194-31.44829-22.87145-52.68817-21.22331Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.43183,644.51336c-.97016,1.022-1.93931,2.053-2.9116,3.057a369.22271,369.22271,0,0,1-29.43114,27.34954l93.86656-6.93884-.395,1.13938a146.38008,146.38008,0,0,0,26.8-25.43q4.5855-5.66379,8.86549-11.5Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.49708,546.00263c11.17194-18.323,20.93962-36.11873,29.20674-52.22972l-21.4972-91.41867.90343-.78535c-16.0432,1.45228-33.59169,7.67256-51.41083,18.27678Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980.06759,676.01285,946.47812,544.625c-27.1027,75.34348-32.42465,164.87975-32.73986,170.58276C937.47626,706.23654,959.65656,692.49859,980.06759,676.01285Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1016.2,642.29608l.09162-.01165a501.53649,501.53649,0,0,0,34.83028-41.249L997.14839,459.58986q-7.46154,7.90527-14.68121,16.80483a179.71138,179.71138,0,0,0-17.98056,27.332Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M841.58618,384.75462l-3.527,55.22757c9.28814,15.79282,19.2011,33.785,28.79227,53.2579l11.0612-83.61809.85057.68831c-12.37394-11.1185-25.22359-20.00463-38.03612-26.1676Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.42487,437.21468l3.41711-53.49731c-14.40456-6.788-28.74676-10.11281-42.29611-9.23392-.70493.04575-1.40016.11139-2.09419.17928C798.42082,378.66238,815.6909,402.25414,836.42487,437.21468Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.00805,516.31637l.78934.94281q-4.296-10.85165-9.3095-21.20819l-35.702,94.68259-.37772-.41649q1.96671,6.7146,3.67995,13.31233Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.49016,456.67535l.83024.83228A258.75348,258.75348,0,0,0,879.61908,411.092l-11.27269,85.2113q13.35918,27.43835,23.406,53.72609Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.82239,463.18244a216.05215,216.05215,0,0,0,3.72357,43.38627l145.99626,31.8041c-6.11582-15.08431-12.57928-29.31764-18.9428-42.343l-130.53175-31.644Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.13155,523.112l-.26774-1.20373,148.00061,30.05713q-2.11422-5.60271-4.30529-11.07155l-146.535-31.92146-.25949-1.20453Q741.186,515.32778,743.13155,523.112Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M940.03237,493.83011l.81.89323a309.00289,309.00289,0,0,0-20.7719-36.10366l-27.0991,94.61652q6.5998,17.567,11.6565,34.48745Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M918.79922,654.57887c3.05722,26.37584,2.58145,50.93709-1.44417,73.40989,10.35779-16.87425,50.42721-87.09884,46.25765-157.20262Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.72446,578.16512a298.92554,298.92554,0,0,0,22.39181,33.16344L786.9,610l129.90819,42.27352a371.63113,371.63113,0,0,0-8.18059-43.78089Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.17664,437.98329c-22.44228-37.81923-40.76408-62.18672-41.02788-62.5357l.425-.696c-20.50737,2.29674-36.15338,14.31893-46.13157,33.14138Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.95175,607.03871c.34385,1.36652.69591,2.73706,1.02344,4.09577a369.22132,369.22132,0,0,1,7.34535,39.49981L962.709,567.63584l.75094.94355a146.37993,146.37993,0,0,0-7.13258-36.24986q-2.32916-6.90511-4.96749-13.64447Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M865.32366,493.4337c-9.49577-19.24511-19.298-37.02188-28.48039-52.62931L748.11892,410.023l-.17971-1.1835c-7.3617,14.32826-11.50195,32.48039-12.08422,53.20795Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.09086,654.61611,788.1334,612.65177c49.12967,63.22556,121.907,115.65192,126.5553,118.97113C919.81885,706.77021,920.08888,680.68145,917.09086,654.61611Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M907.95481,606.04767l.0392-.08362a501.53715,501.53715,0,0,0-16.19511-51.50091L743.43413,524.33187q2.68278,10.53425,6.33486,21.39648a179.711,179.711,0,0,0,13.46035,29.81876Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#6760dc",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 686,
    cy: 230.0001,
    r: 60.00001,
    fill: "#2f2e41",
    style: {
      fill: "rgb(86, 79, 217)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 751,
    cy: 151.0001,
    r: 60.00001,
    fill: "#2f2e41",
    style: {
      fill: "rgb(86, 79, 217)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.20534,304.40785a60.00326,60.00326,0,0,1-92.6559-31.505,60.00331,60.00331,0,1,0,117.04384-24.60556A59.98115,59.98115,0,0,1,834.20534,304.40785Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#2f2e41",
    style: {
      fill: "rgb(86, 79, 217)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 670.49995,
    cy: 253.50008,
    r: 49,
    fill: "#a0616a",
    style: {
      fill: "rgb(122, 116, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.95212,397.224s20,30,17,43c0,0-13,6-13,8s-12,21-12,21l-14,19-6,25h29l32-25,31-34s21-10,32-2l6,5s-21-28-31-34c0,0-18-22-16-44Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#a0616a",
    style: {
      fill: "rgb(122, 116, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.95212,439.224s-20,11-28,32-44,91-44,91-3,45-1,47,25-20,29-26,20-78,20-78l26-42,5-24Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#a0616a",
    style: {
      fill: "rgb(122, 116, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.95212,565.22395l-9-3s-55-34-58-49-47-65-48-38,32,57,32,57,72,101,76,72Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#a0616a",
    style: {
      fill: "rgb(122, 116, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.95212,496.224s1,28,40,38c0,0,40,54,44,78s109,147,109,147,97,12,97,0-81-22-81-22-85-126-89-143-42-143-60-142c0,0-17-8-27-2S720.95212,496.224,720.95212,496.224Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#a0616a",
    style: {
      fill: "rgb(122, 116, 224)"
    }
  }), _ref2, /*#__PURE__*/React.createElement("path", {
    d: "M603.95212,609.22395s-70-94-85-100-34-10-45,4-141,178-141,178-46,47-69,38c0,0-12,10,16,12s54-6,54-6,17,3,29,6,27,4,26-4l-4-32s103-85,106-121c0,0-2-17,0-15s44,47,63,57,66,24,66,24Z",
    transform: "translate(-31.45212 -103.72389)",
    style: {
      fill: "rgb(86, 79, 217)",
      stroke: "rgb(86, 79, 217)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.95212,622.22395s-92-35-104-43-55-24-77-6-129,101-165,109-98,27-98,27-40,3,3,20c0,0,53,5,62,13s39,18,41,5,8-30,19-32,143-38,163-77c0,0,45,25,73,54s94,45,94,45Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#a0616a",
    style: {
      fill: "rgb(122, 116, 224)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.95212,590.22395s-43.83517,11.65172-47.41758,7.32586-22.58242,19.67414-4.58242,67.67414,14,70,24,77,57-4,71,1,32,9,38-20,21-80,18-87-19-23-19-23l-33-17Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#3f3d56",
    style: {
      fill: "rgb(240, 98, 59)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M799.45212,477.724s-6.96182-19.50105-19.88546-23.15706a33.20394,33.20394,0,0,1-3.22618-1.058c-4.85461-1.92741-19.66336-6.13491-30.38836,8.71509-13,18-25,39-15,51s30,19,30,19l15,19s-30,54-30,79c0,0-1,10-18-8s-86.56887-30.44484-86.56887-30.44484,14.56887-19.55516,3.56887-28.55516-21.07086-44.84842,4.96457-58.92421L694.45212,438.724l8,1s-10.5,9.5-11.5,14.5-41,40-25,46,42-7,53-22c6.05-8.25,14.52-19.525,25.24363-26.67087a37.38913,37.38913,0,0,1,37.39866-2.008l3.35771,1.67885h0a42.838,42.838,0,0,1,14.80839,18.21957l1.1916,2.78042Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#2f2e41",
    style: {
      fill: "rgb(245, 118, 78)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 701.99999,
    cy: 240.00009,
    r: 44.00001,
    fill: "#2f2e41",
    style: {
      fill: "rgb(86, 79, 217)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 665,
    cy: 223.50006,
    rx: 39,
    ry: 30.5,
    fill: "#2f2e41",
    style: {
      fill: "rgb(86, 79, 217)"
    }
  }), _ref3, /*#__PURE__*/React.createElement("path", {
    d: "M721.95212,274.08394v79.64h-23v-79.64a5.36021,5.36021,0,0,1,5.35987-5.36h12.28027A5.3602,5.3602,0,0,1,721.95212,274.08394Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#ff6584",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679,
    cy: 266.00007,
    r: 25.00001,
    fill: "#6760dc",
    style: {
      fill: "rgb(255, 255, 255)"
    }
  }), _ref4, _ref5, /*#__PURE__*/React.createElement("path", {
    d: "M721.95212,274.08394v3.64h-23v-3.64a5.36021,5.36021,0,0,1,5.35987-5.36h12.28027A5.3602,5.3602,0,0,1,721.95212,274.08394Z",
    transform: "translate(-31.45212 -103.72389)",
    opacity: 0.1,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.80585,471.37023l58.88009-58.88009a10.983,10.983,0,0,1,15.53237,0l52.96763,52.96762a10.98307,10.98307,0,0,1,0,15.53238L527.1721,536.004a10.983,10.983,0,0,1-14.9464.54476l-56.83388-49.10137A10.98305,10.98305,0,0,1,454.80585,471.37023Z",
    transform: "translate(-31.45212 -103.72389)",
    fill: "#2f2e41",
    style: {
      fill: "rgb(100, 190, 181)",
      stroke: "rgb(100, 190, 181)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "440 377 491.5 325.5 534 368 484.5 417.5 440 377",
    fill: "#f2f2f2",
    style: {
      fill: "rgb(87, 156, 149)",
      stroke: "rgb(87, 156, 149)"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderImage);
export default __webpack_public_path__ + "static/media/header-image.938fe149.svg";
export { ForwardRef as ReactComponent };